(function () {
    'use strict';

    angular.module('sempraWebapp').factory('PeriodicSummaryViewModel', periodicSummaryViewModelFactory);

    /** @ngInject */
    function periodicSummaryViewModelFactory(DateTime, $filter, invoiceNamingEnumFactory, InvoiceStatusEnum, $translate) {
        function PeriodicSummaryViewModel() {

            this.currency = '';
            this.companyName = '';
            this.grossIncome = 0;
            this.commissionFee = 0;
            this.netIncome = 0;
            this.totalData = {};
            this.currentMonthData = {};
            this.invoiceNaming = {
                name: invoiceNamingEnumFactory.name,
                invoiceNumber: invoiceNamingEnumFactory.invoiceNumber,
                invoiceState: invoiceNamingEnumFactory.invoiceState
            }

            this.financialData = {
                currentPeriod : {},
                paymentsOnHold : {
                    collapsed : false,
                    description : invoiceNamingEnumFactory.paymentsOnHold,
                    total : {},
                    data : []
                },
                forInvoicing : {
                    collapsed : false,
                    description : invoiceNamingEnumFactory.forInvoicing,
                    total : {},
                    data : []
                }
            };

            this.downloadOptions = [];

            this.forSerbiaRegion = [{
                name: $translate.instant('DOWNLOAD_INVOICE'),
                type: 'invoice'
            }];

            this.allRegions = [
                {
                    name: $translate.instant('DOWNLOAD_PAYMENT_REQUEST'),
                    type: 'invoice'
                },
                {
                    name: $translate.instant('B2B_SPEC'),
                    type: 'b2b'
                },
                {
                    name: $translate.instant('B2C_SPEC'),
                    type: 'b2c'
                }
            ]

            // INVOICES
            this.selectedYear;
            this.invoiceFromYear = [];
            this.currentYear = new Date().getFullYear();
            this.selectedYear = this.currentYear;
            this.minYear = 2014;
            this.maxYear = this.currentYear + 1;
            this.searchRadioButton = {type: ''};
            this.selectedYear = this.currentYear;

            this.invoiceFrom = new Date(new DateTime().startOf(DateTime.units.MONTH).timestamp);
            this.invoiceTo  = new Date(new DateTime().endOf(DateTime.units.DAY).timestamp);
            this.invoiceStatuses = InvoiceStatusEnum;

            // GRID CONFIIG
            this.invoiceData = [];
            this.invoiceOrderBy = "-date";
            this.invoiceOrder = 'desc';
            this.invoicePage = 1;
            this.invoiceTotal = 0;
            this.invoicePageSize = 10;
            this.invoicePageOptions = [5, 10, 15];
            this.selectedInvoices = [];
            this.pagerTranslations = {
                page: $translate.instant('GRID_PAGER_PAGE'),
                rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
                of: $translate.instant('GRID_PAGER_PAGE_OF')
            };
        }

        PeriodicSummaryViewModel.prototype.destroy = function () {
        };

        PeriodicSummaryViewModel.prototype.refresh = function (data) {
            this.currency = data.currencyCode;
            this.companyName = data.companyName;

            this.totalData = data.total;
            this.currentMonthData = data.currentMonth;

            this.financialData.currentPeriod = data.currentPeriod;
            this.financialData.paymentsOnHold.data = data.paymentsOnHold.transactions;
            this.financialData.paymentsOnHold.total = data.paymentsOnHold.total;
            this.financialData.forInvoicing.data = data.forInvoicing.transactions;
            this.financialData.forInvoicing.total = data.forInvoicing.total;
        };

        PeriodicSummaryViewModel.prototype.refreshInvoiceData = function(data){

            this.images = [{src: "assets/icons/ic_arrow_back_red_24px.svg"},{src: "assets/icons/ic_arrow_forward_green_24px.svg"}];

            this.invoiceData = data.content;
            this.invoiceTotal = data.totalElements;

        };

        PeriodicSummaryViewModel.prototype.invoiceOrderingChange = function(order){
            var orderQuery = getOrderObject(order);
            this.invoiceOrderBy = orderQuery.orderBy;
            this.invoiceOrder = orderQuery.order;
        };

        PeriodicSummaryViewModel.prototype.invoicePaginationChange = function(page, limit){
            this.invoicePage = page;
            this.invoicePageSize = limit;
            this.invoiceOrderingChange(this.invoiceOrderBy);
        };

        return PeriodicSummaryViewModel;

        function getOrderObject(order) {
            var result = {
                order: 'asc',
                orderBy: order
            };

            if (order.indexOf('-') > -1) {
                result.order = 'desc';
                result.orderBy = order.substring(1);
            }
            return result;
        }
    }
})();
